module.exports = __webpack_public_path__ + "img/BQ-SA.91591c34.svg";